import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import Clarity from '@microsoft/clarity'

const projectId = 'qss4z0iqim'

Clarity.init(projectId)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
